import { useMemo } from "react";
import useCurrentUser from "./useCurrentUser";
import { rgbaObjectToString } from "../helpers/utils";

interface IRgbaColor {
  r: string;
  g: string;
  b: string;
  a: string;
}

export default function useColors() {
  const { colors: userCustomColors } = useCurrentUser();

  const getColorWithFullOpacity = (color: IRgbaColor) => {
    return rgbaObjectToString({ ...color, a: 1 });
  };

  const colors = useMemo(() => {
    return {
      income: {
        color: getColorWithFullOpacity(
          userCustomColors.transactions.income.color
        ),
        bg: getColorWithFullOpacity(userCustomColors.transactions.income.bg),
      },
      expenses: {
        color: getColorWithFullOpacity(
          userCustomColors.transactions.expenses.color
        ),
        bg: getColorWithFullOpacity(userCustomColors.transactions.expenses.bg),
      },
      difference: {
        positive: {
          color: getColorWithFullOpacity(
            userCustomColors.balance.positive.color
          ),
          bg: getColorWithFullOpacity(userCustomColors.balance.positive.bg),
        },
        negative: {
          color: getColorWithFullOpacity(
            userCustomColors.balance.negative.color
          ),
          bg: getColorWithFullOpacity(userCustomColors.balance.negative.bg),
        },
      },
    };
  }, [userCustomColors]);

  return {
    colors,
    rgbaObjectToString,
  };
}
